import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cómo accedo?',
  answer: 'El acceso es inmediato luego de completar la compra.'
}, {
  question: '¿Es un curso con videos?',
  answer: 'No. Todo el contenido está desarrollado en formato 100% PDF para que avances a tu ritmo.'
}, {
  question: '¿Necesito conocimientos previos?',
  answer: 'No. La formación comienza desde los fundamentos.'
}, {
  question: '¿El acceso vence?',
  answer: 'No. El acceso es ilimitado.'
}, {
  question: '¿Tiene garantía?',
  answer: 'Sí. Contás con una garantía de satisfacción de 7 días.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-rose/35 px-4 py-20 md:py-28" data-id="element-70" data-mp="1v7c8c4gbgi0a">
      <div className="mx-auto max-w-3xl" data-id="element-71" data-mp="opp3nvsnze9w">
        <div className="text-center" data-id="element-72" data-mp="jpsuzj90uyo0">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-clay-dark" data-id="element-73" data-mp="jorj5ck6m858">Para decidir con claridad</p>
          <h2 className="mt-3 font-heading text-4xl font-semibold text-ink md:text-5xl" data-id="element-74" data-mp="1kp1jd8z4a9pb">Preguntas frecuentes</h2>
        </div>

        <div className="mt-12 overflow-hidden rounded-2xl border border-clay/20 bg-white" data-id="element-75" data-mp="1pkqn7oi66crf">
          {faqs.map((faq, index) => {
          const isOpen = index === openIndex;
          return <div key={faq.question} className="border-b border-clay/15 last:border-b-0" data-id="element-76" data-mp="1fmsq0bic15mo" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left text-base font-bold text-ink transition-colors hover:bg-paper focus-visible:outline-none md:px-7" data-id="element-77" data-mp="11vnzbywxznoh">
                  {faq.question}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-clay-dark transition-transform ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-78" data-mp="ww1htda2zl9v" />
                </button>
                <AnimatePresence initial={false} data-id="element-79" data-mp="mzghh590aycd">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22
              }} data-id="element-80" data-mp="2pn54z4acwudc">
                      <p className="border-t border-clay/10 px-6 pb-6 pt-4 text-sm leading-6 text-ink/65 md:px-7" data-id="element-81" data-mp="2azk4zj8s3b9n">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}